export const getCorrectReportType = (t, reportType) => {
  switch (reportType?.toLowerCase()) {
    case "place":
      return t("reports.place");
    case "comment":
      return t("reports.comment");
    case "message":
      return t("reports.message");
    case "channelcomment":
      return t("reports.channelComment");
    case "placereview":
      return "Place Review";
    default:
      return reportType || t("reports.unknown");
  }
};

export const getCorrectReason = (t, reason) => {
  if (!reason) return "Unknown";

  switch (reason.toLowerCase()) {
    case "spam":
      return t("reports.spam");
    case "harassment":
      return t("reports.harassment");
    case "inappropriate_content":
      return t("reports.inappropriateContent");
    case "misinformation":
      return t("reports.misinformation");
    case "violence":
      return t("reports.violence");
    case "hate_speech":
      return t("reports.hateSpeech");
    case "fake_information":
      return t("reports.fakeInformation");
    case "other":
      return t("reports.other");
    default:
      return t("reports.unknownReason");
  }
};

export const getCorrectDate = (t, date) => {
  if (!date) return t("reports.noDate");

  const d = new Date(date);
  const dateStr = d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const time = d
    .toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toLowerCase();

  return `${dateStr} • ${time}`;
};

export const getCorrectCategoryPlace = (t, category) => {
  if (!category) return "Unknown";

  switch (category) {
    case "foodRestaurants":
      return t("home.places.foodRestaurants");
    case "hospitals":
      return t("home.places.hospitals");
    case "shopService":
      return t("home.places.shopService");
    case "organizations":
      return t("home.places.organizations");
    case "transportation":
      return t("home.places.transportation");
    case "hotelHostel":
      return t("home.places.hotelHostel");
    case "myLocation":
      return t("home.places.myLocation");
    case "myFavourite":
      return t("home.places.myFavourite");
    default:
      return category;
  }
};
